var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"stiReportsContainer",staticStyle:{"width":"100%"},attrs:{"id":"stiDashboardsContainer"}},[_c('h5',[_vm._v("Dashboard")])])])
}]

export { render, staticRenderFns }